import { useRef, useCallback } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export function ContentRail({ icon, title, subtitle, seeAllPath, navigate, children, testId }) {
  const scrollRef = useRef(null);

  const scroll = useCallback((dir) => {
    if (!scrollRef.current) return;
    scrollRef.current.scrollBy({ left: dir * 340, behavior: 'smooth' });
  }, []);

  return (
    <section className="py-5 sm:py-6" data-testid={testId}>
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header row */}
        <div className="flex items-center justify-between mb-3.5">
          <div className="flex items-center gap-2.5 min-w-0">
            {icon}
            <div className="min-w-0">
              <h2 className="text-base sm:text-lg font-bold text-white tracking-tight truncate">{title}</h2>
              {subtitle && <p className="text-gray-500 text-[11px] mt-0.5">{subtitle}</p>}
            </div>
          </div>
          <div className="flex items-center gap-2 shrink-0 ml-4">
            {/* Scroll arrows — desktop */}
            <div className="hidden sm:flex items-center gap-1">
              <button
                onClick={() => scroll(-1)}
                className="w-8 h-8 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors"
                data-testid={`${testId}-scroll-left`}
                aria-label="Scroll left"
              >
                <ChevronLeft className="w-4 h-4 text-white/70" />
              </button>
              <button
                onClick={() => scroll(1)}
                className="w-8 h-8 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors"
                data-testid={`${testId}-scroll-right`}
                aria-label="Scroll right"
              >
                <ChevronRight className="w-4 h-4 text-white/70" />
              </button>
            </div>
            {seeAllPath && (
              <button
                onClick={() => navigate(seeAllPath)}
                className="text-emerald-500 hover:text-emerald-400 text-[11px] font-semibold tracking-wide uppercase transition-colors whitespace-nowrap"
                data-testid={`${testId}-see-all`}
              >
                See All
              </button>
            )}
          </div>
        </div>

        {/* Horizontal scroll rail */}
        <div
          ref={scrollRef}
          className="flex gap-3 overflow-x-auto pb-1 snap-x snap-mandatory"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none', WebkitOverflowScrolling: 'touch' }}
          data-testid={`${testId}-scroll`}
        >
          {children}
        </div>
      </div>
    </section>
  );
}
